import { DEFAULT_TAB } from "./constants";
import { Tab, TabSize } from "./types";

export const getFirstEnabledTab = (tabs: Tab[], defaultIndex: number) =>
  tabs.findIndex((x) => !x.disabled) || defaultIndex;

export const getIndexFromKey = (tabs: Tab[], tab: string, keys: string[]) => {
  const i = keys.findIndex((key) => key === tab);

  if (tabs[i]?.disabled) {
    return getFirstEnabledTab(tabs, DEFAULT_TAB);
  }

  return i;
};

export const getQueryContentToPersist = (
  otherQueryParams: qs.ParsedQs,
  queryParamsToPersist?: string[]
) => {
  if (!queryParamsToPersist) return {};

  return Object.keys(otherQueryParams).reduce((acc, key) => {
    if (queryParamsToPersist.includes(key)) {
      Object.assign(acc, { ...acc, [key]: otherQueryParams[key] });
    }

    return acc;
  }, {});
};

export const getSizeClassName = (size: TabSize) =>
  `MuiTabs-size${size?.charAt(0).toUpperCase() + size.slice(1)}`;
